import logoImageDesktop from '../assets/bean_pigeon_400_96_caps.png';
import logoImageMobile from '../assets/bean_pigeon_favicon_ead.png';

export const marketplaceColor = '#153a2b';
export const useHostedAssets = false;

export const logoImageDesktopURL = logoImageDesktop;
export const logoImageMobileURL = logoImageMobile;

export const logoSettings = {
  height: 28,
  format: 'image',
};

export const brandImageURL = null;
export const facebookImageURL = null;
export const twitterImageURL = null;